import { createSlice } from "@reduxjs/toolkit";

export const headerDataSlice = createSlice({
  name: 'header',
  initialState: {},
  reducers: {
    setHeaderData: (state, action) => {
      return { ...state, ...action.payload };
    },
  // reducers: {
  //   setHeaderData: (state, action) => {
  //       state = action.payload,
  //           console.log('action api Data', action.payload);

  //   }
}
});

export const { setHeaderData } = headerDataSlice.actions;
export default headerDataSlice.reducer;
